import React from "react";
import Layout from "../../layout/Layout";
import "animate.css";
import sumly_shopping from "../../assets/sumly_shopping.png";
import sumly_ats from "../../assets/sumly_ats.png";
import sumly_webpage from "../../assets/sumly_webpage.png";
import sumly_targetwebpage from "../../assets/sumly_targetwebpage.png";
import sumly_socialmedia from "../../assets/sumly_socialmedia.png";
import sumly_aichat from "../../assets/sumly_aichat.png";
import sumly_youtube from "../../assets/sumly_youtube.png";
import sumly_calendar from "../../assets/sumly_calendar.png";
import sumly_github from "../../assets/sumly_github.png";
import sumly_emails from "../../assets/sumly_emails.png";
import sumly_forms from "../../assets/sumly_forms.png";
import sumly_document from "../../assets/sumly_document.png";

function Sumly() {
  const features = [
    "E-Sign PDF",
    "ATS Resume Fix",
    "Web Pages",
    "Selected Text",
    "Shopping Product",
    "Social Media",
    "YouTube",
    "GitHub",
    "AI Chats",
    "Emails",
    "Documents",
    "Google Calendar",
    "Forms",
  ];

  const handleFeatureClick = (feature) => {
    // Map features to their corresponding image IDs
    const imageMap = {
      "E-Sign PDF": "video-esign",
      "ATS Resume Fix": "image-ats",
      "Web Pages": "image-web-pages",
      "Selected Text": "image-target-web-pages",
      Documents: "image-documents",
      "Shopping Product": "image-shopping",
      "Social Media": "image-social",
      YouTube: "image-youtube",
      "AI Chats": "image-ai-chats",
      GitHub: "image-github",
      Emails: "image-emails",
      "Google Calendar": "image-calendar",
      Forms: "image-forms",
    };

    const imageId = imageMap[feature];
    if (!imageId) return;

    // First, scroll to the images container
    const imagesContainer = document.getElementById("sumly-images");
    if (imagesContainer) {
      imagesContainer.scrollIntoView({ behavior: "smooth" });
    }

    // Then, after a short delay, scroll to the specific image
    setTimeout(() => {
      const imageElement = document.getElementById(imageId);
      const scrollContainer = document.getElementById(
        "images-scroll-container"
      );

      if (imageElement && scrollContainer) {
        // Calculate the position relative to the scroll container
        const containerRect = scrollContainer.getBoundingClientRect();
        const elementRect = imageElement.getBoundingClientRect();
        const scrollPosition =
          elementRect.top - containerRect.top + scrollContainer.scrollTop;

        scrollContainer.scrollTo({
          top: scrollPosition,
          behavior: "smooth",
        });
      }
    }, 500); // Short delay to allow the container to scroll into view first
  };

  return (
    <Layout>
      <div className="pt-16 md:pt-20 bg-white">
        <div className="flex flex-col space-y-2 sm:space-y-10 mx-auto py-2 ">
          <div className="flex justify-center items-center pl-6 pr-6 pb-16 md:pl-12 md:pr-12 lg:pl-24 lg:pr-24 bg-white animate__animated animate__fadeIn">
            <div className="grid grid-cols-1 max-w-4xl items-stretch mx-auto gap-12">
              <a href="#access_points">
                <p className="text-4xl md:text-5xl text-center leading-normal xs:leading-normal md:leading-normal">
                  Sumly
                  <span className="inline-block align-top -translate-y-2 transform ml-2">
                    {"\u2197"}
                  </span>
                </p>
              </a>

              <div className="flex flex-col justify-center items-center gap-4">
                <p className="text-xl md:text-2xl text-center leading-normal xs:leading-normal md:leading-normal">
                  Sumly is a Chrome extension that lets you instantly summarize
                  webpages, shopping products, AI chats, emails, videos, files,
                  calendar events, and more in your preferred language and
                  format. It helps you analyze and enhance your resume with
                  personalized ATS fixes by comparing it against job
                  descriptions. You can also e-sign multi-page PDFs completely
                  offline, with no internet or API key required.
                </p>
                <p className="text-md md:text-lg text-slate-600 text-center leading-normal xs:leading-normal md:leading-normal">
                  {" "}
                  Explore each feature to understand its purpose, with a
                  supporting image or video.
                </p>
                <div className="grid grid-cols-2 sm:flex sm:gap-2 gap-2">
                  <a href="#installation" className="w-full xs:w-auto">
                    <button className="w-full hover:bg-black bg-white text-black hover:text-white font-normal text-md py-3 px-3 border border-gray-300 rounded-xl transition duration-300 ease-in-out">
                      Installation
                    </button>
                  </a>
                  <a href="#access_points" className="w-full xs:w-auto">
                    <button className="w-full hover:bg-black bg-white text-black hover:text-white font-normal text-md py-3 px-3 border border-gray-300 rounded-xl transition duration-300 ease-in-out">
                      Resource Links
                    </button>
                  </a>
                  <a href="#problem_solving" className="w-full xs:w-auto">
                    <button className="w-full hover:bg-black bg-white text-black hover:text-white font-normal text-md py-3 px-3 xs:px-2 border border-gray-300 rounded-xl transition duration-300 ease-in-out">
                      Problem Solving
                    </button>
                  </a>
                  <a href="#sumly-images" className="w-full xs:w-auto">
                    <button className="w-full hover:bg-black bg-white text-black hover:text-white font-normal text-md py-3 px-3 border border-gray-300 rounded-xl transition duration-300 ease-in-out">
                      Features
                    </button>
                  </a>
                  <a href="#all-about-sumly" className="w-full xs:w-auto">
                    <button className="w-full hover:bg-black bg-white text-black hover:text-white font-normal text-md py-3 px-3 border border-gray-300 rounded-xl transition duration-300 ease-in-out">
                      All about Sumly
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div
            className="flex justify-center items-center pt-16 pl-6 pr-6 pb-8 sm:p-16 md:p-24 md:pl-12 md:pr-12 md:pt-20 lg:pl-24 lg:pr-24 bg-gray-50"
            id="publications"
          >
            <div className="grid grid-cols-1 gap-16 md:gap-20 items-stretch max-w-6xl mx-auto">
              {/* Installation */}
              <div
                id="installation"
                className="grid grid-cols-1 lg:grid-cols-1 items-center gap-12 p-8 md:p-12 bg-white shadow-md rounded-2xl"
              >
                <div>
                  <div className="flex justify-center items-center gap-2">
                    <a
                      href="https://chromewebstore.google.com/detail/honfjipamlobaeefcpggckeghjpolmjj?utm_source=item-share-cb"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <h2 className="text-2xl font-semibold mb-6 text-center pb-2">
                        INSTALLATION
                        <span className="inline-block align-top -translate-y-2 transform ml-2">
                          {"\u2197"}
                        </span>
                      </h2>
                    </a>
                    <div className="flex justify-center items-center gap-1 mb-7">
                      <div className="relative text-xs text-gray-500 rounded-[12px] px-1.5 border border-gray-500 group">
                        i
                        <div className="hidden group-hover:block absolute right-5 bottom-[-10px] bg-white text-black border border-gray-300 rounded-xl text-xs px-3 py-2 z-[1000] w-[263px] pointer-events-none">
                          You don't need an API key or an internet connection to
                          use the eSignPDF feature, it works completely offline.
                          Just open the extension and start e-signing your PDFs{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-center">
                    <div className="max-w-6xl">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">Step 1</div>
                          <div className="text-sm">
                            Install the extension and enter your Gemini API key
                            if you already have one. If not, click on the{" "}
                            <a
                              href="https://aistudio.google.com/app/apikey"
                              target="_blank"
                              rel="noreferrer"
                              className="hover:underline text-blue-700"
                            >
                              Google AI Studio
                            </a>{" "}
                            link to get one.
                          </div>
                        </div>
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">Step 2</div>
                          <div className="text-sm">
                            After clicking the Google AI Studio link, you'll be
                            redirected to the API key page, where you need to
                            click on the 'Get API Key' option.
                          </div>
                        </div>
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">Step 3</div>
                          <div className="text-sm">
                            Then, select the required options to agree to the
                            API policy and click 'I Accept'.
                          </div>
                        </div>
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">Step 4</div>
                          <div className="text-sm">
                            Click on 'Create API Key' to generate your API key,
                            then click 'Copy' to copy it and paste it into the
                            extension settings window.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Problem Statement Flow */}
              <div
                id="problem_solving"
                className="grid grid-cols-1 lg:grid-cols-1 items-center gap-12 p-8 md:p-12 bg-white shadow-md rounded-2xl"
              >
                <div>
                  <h2 className="text-2xl font-semibold mb-6 text-center pb-2">
                    PROBLEM IDENTIFICATION
                  </h2>
                  <div className="flex justify-center">
                    <div className="max-w-6xl">
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">ISSUE 1</div>
                          <div className="text-sm">
                            Spending hours reading lengthy blogs, articles, and
                            web content
                          </div>
                        </div>
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">ISSUE 2</div>
                          <div className="text-sm">
                            Wasting time watching long YouTube videos for key
                            insights
                          </div>
                        </div>
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">ISSUE 3</div>
                          <div className="text-sm">
                            Struggling to understand complex GitHub repositories
                            and documentation
                          </div>
                        </div>
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">ISSUE 4</div>
                          <div className="text-sm">
                            Recalling email details by reading entire threads
                            from top to bottom
                          </div>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-4">
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">ISSUE 5</div>
                          <div className="text-sm">
                            Analyzing product reviews and specifications across
                            multiple shopping sites
                          </div>
                        </div>
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">ISSUE 6</div>
                          <div className="text-sm">
                            Revisiting ChatGPT conversation history to find
                            previous discussions
                          </div>
                        </div>
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">ISSUE 7</div>
                          <div className="text-sm">
                            Processing lengthy PDF documents and presentations
                            for key points
                          </div>
                        </div>
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">ISSUE 8</div>
                          <div className="text-sm">
                            Extracting insights from social media profiles and
                            posts manually
                          </div>
                        </div>
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">ISSUE 9</div>
                          <div className="text-sm">
                            Struggling to tailor your resume to match job
                            descriptions and pass ATS scans
                          </div>
                        </div>
                        <div className="border-2 border-gray-600 p-4 text-center">
                          <div className="font-bold mb-2">ISSUE 10</div>
                          <div className="text-sm">
                            Wasting time and money searching for a way to e-sign
                            your PDFs
                          </div>
                        </div>
                      </div>

                      <div className="text-center mt-6 pt-2">
                        <a
                          href="https://chromewebstore.google.com/detail/honfjipamlobaeefcpggckeghjpolmjj?utm_source=item-share-cb"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <div className="inline-block border-2 border-black p-4 bg-gray-100">
                            <strong className="text-xl">
                              UNIFIED SOLUTION: SUMLY
                            </strong>
                            <br />
                            <span className="text-sm">
                              Summarize • ATSFix • esignPDF
                            </span>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/*Examples*/}
              <div
                className="grid grid-cols-1 lg:grid-cols-1 items-center gap-12 p-8 md:p-12 bg-white shadow-md rounded-2xl"
                id="sumly-images"
              >
                <div>
                  <div className="flex flex-col justify-center items-center mb-6">
                    <h2 className="text-2xl font-semibold text-center pb-4">
                      FEATURES IN ACTION
                    </h2>

                    <p className="text-md md:text-lg text-slate-600 text-center leading-normal xs:leading-normal md:leading-normal">
                      {" "}
                      Click on each feature to understand its functionality,
                      supported by an image or a video showing its usage.
                    </p>
                  </div>
                  <div className="grid grid-cols-1 gap-10 max-w-5xl mx-auto">
                    <div className="flex flex-wrap gap-1.5 xs:gap-2">
                      {features.map((feature, index) => (
                        <div
                          key={index}
                          className="flex"
                          onClick={() => handleFeatureClick(feature)}
                        >
                          <button className="w-full bg-black hover:bg-white hover:text-black text-white font-semibold text-[12px] xs:text-[13px] py-2 px-3 md:py-3 md:px-4 border border-gray-700 rounded-xl transition duration-300 ease-in-out">
                            {feature}
                          </button>
                        </div>
                      ))}
                    </div>
                    <div
                      id="images-scroll-container"
                      className="w-full h-[14rem] xs:h-[18rem] sm:h-[20rem] md:h-[24rem] slg:h-[28rem] lg:h-[31rem] overflow-y-scroll hide-scrollbar rounded-xl border border-gray-200"
                    >
                      <div
                        style={{
                          position: "relative",
                          paddingTop: "56.25%" /* 16:9 ratio */,
                        }}
                      >
                        <iframe
                          src="https://www.loom.com/embed/4cccb8ccd2874348ad04c72e77206309?sid=ba24d2e8-d034-4d6d-9a62-3481f3cb1e64"
                          frameBorder="0"
                          allowFullScreen
                          webkitAllowFullScreen
                          mozAllowFullScreen
                          title="Loom Video"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                          }}
                        ></iframe>
                      </div>
                      <hr className="border-t-2 border-gray-300 my-10" />
                      <img
                        id="image-ats"
                        src={sumly_ats}
                        alt="ATS Resume Example"
                        className="w-full h-50 object-contain"
                      />
                      <hr className="border-t-2 border-gray-300 my-10" />
                      <img
                        id="image-web-pages"
                        src={sumly_webpage}
                        alt="Web Pages Example"
                        className="w-full h-50 object-contain"
                      />
                      <hr className="border-t-2 border-gray-300 my-10" />
                      <img
                        id="image-target-web-pages"
                        src={sumly_targetwebpage}
                        alt="Web Pages Example"
                        className="w-full h-50 object-contain"
                      />
                      <hr className="border-t-2 border-gray-300 my-10" />
                      <img
                        id="image-documents"
                        src={sumly_document}
                        alt="Documents Example"
                        className="w-full h-50 object-contain"
                      />
                      <hr className="border-t-2 border-gray-300 my-10" />
                      <img
                        id="image-shopping"
                        src={sumly_shopping}
                        alt="Shopping Platforms Example"
                        className="w-full h-50 object-contain"
                      />
                      <hr className="border-t-2 border-gray-300 my-10" />

                      <img
                        id="image-social"
                        src={sumly_socialmedia}
                        alt="Social Media Example"
                        className="w-full h-50 object-contain"
                      />
                      <hr className="border-t-2 border-gray-300 my-10" />
                      <img
                        id="image-youtube"
                        src={sumly_youtube}
                        alt="YouTube Example"
                        className="w-full h-50 object-contain"
                      />
                      <hr className="border-t-2 border-gray-300 my-10" />
                      <img
                        id="image-ai-chats"
                        src={sumly_aichat}
                        alt="AI Chats Example"
                        className="w-full h-50 object-contain"
                      />
                      <hr className="border-t-2 border-gray-300 my-10" />
                      <img
                        id="image-github"
                        src={sumly_github}
                        alt="GitHub Example"
                        className="w-full h-50 object-contain"
                      />
                      <hr className="border-t-2 border-gray-300 my-10" />
                      <img
                        id="image-emails"
                        src={sumly_emails}
                        alt="Emails Example"
                        className="w-full h-50 object-contain"
                      />

                      <hr className="border-t-2 border-gray-300 my-10" />
                      <img
                        id="image-calendar"
                        src={sumly_calendar}
                        alt="Calendar Example"
                        className="w-full h-50 object-contain"
                      />

                      <hr className="border-t-2 border-gray-300 my-10" />
                      <img
                        id="image-forms"
                        src={sumly_forms}
                        alt="Forms Example"
                        className="w-full h-50 object-contain"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* all about sumly  */}

              <div
                id="all-about-sumly"
                className="grid grid-cols-1 lg:grid-cols-1 items-center gap-12 p-8 md:p-12 bg-white shadow-md rounded-2xl"
              >
                <div>
                  <h2 className="text-2xl font-semibold mb-6 text-center pb-2">
                    ALL ABOUT SUMLY
                  </h2>

                  <div
                    style={{
                      position: "relative",
                      paddingBottom: "56.25%",
                      height: 0,
                    }}
                  >
                    <iframe
                      src="https://www.loom.com/embed/3724d3de2dbf4fe6938d2b0bbf272a6b?sid=33913ff8-c56b-40cd-b392-5b20cea230b8"
                      frameBorder="0"
                      webkitAllowFullScreen
                      mozAllowFullScreen
                      allowFullScreen
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                      }}
                      title="Loom Video"
                    ></iframe>
                  </div>
                </div>
              </div>

              {/* Links Section */}
              <div
                className="grid grid-cols-1 lg:grid-cols-1 items-center gap-12 p-8 md:p-12 bg-white shadow-md rounded-2xl"
                id="access_points"
              >
                <div>
                  <h2 className="text-2xl font-semibold mb-6 text-center pb-2">
                    ACCESS POINTS
                  </h2>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-4xl mx-auto">
                    <a
                      href="https://chromewebstore.google.com/detail/honfjipamlobaeefcpggckeghjpolmjj?utm_source=item-share-cb"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <div className="border-2 border-black p-4 text-center">
                        <div className="font-bold mb-2">CHROME STORE</div>
                        <div className="text-sm">Installation Link</div>
                      </div>
                    </a>
                    <a
                      href="https://github.com/Prabhav25/Sumly"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <div className="border-2 border-black p-4 text-center">
                        <div className="font-bold mb-2">GITHUB</div>
                        <div className="text-sm">GitHub Repo</div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>

              {/* Footer */}
              <div className="grid grid-cols-1 lg:grid-cols-1 items-center gap-12 p-8 md:p-12 bg-white shadow-md rounded-2xl">
                <div className="border-2 border-black p-6 text-center bg-gray-100">
                  <div className="font-bold text-lg mb-2">
                    POWERED BY: GOOGLE GEMINI AI
                  </div>
                  <div className="text-sm">
                    Intelligent • Contextual • Multi-Language • Universal
                  </div>
                  <div className="mt-4 font-bold">
                    Endless Content → Instant Summaries &nbsp; • &nbsp; Resume
                    Gaps → Smart Fixes &nbsp; • &nbsp; PDF Signing → Offline &
                    Easy
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Sumly;
